import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import { IProductGroup } from '../../types/product-group'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'

interface Props {
  productGroups?: string[]
  label?: string
  onSelect: (e: IOptionSelect<IProductGroup>[] | null) => void
  resetAutoComplete?: string
}

const ProductGroupSelectSearch = (props: Props) => {
  const {
    productGroups,
    label = 'เลือกกลุ่มสินค้า',
    onSelect,
    resetAutoComplete = '',
  } = props

  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<
    PaginationResponseInterface<IProductGroup>
  >({
    method: 'GET',
    url: '/product-group',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearch || undefined,
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  return (
    <SelectSearchMultiple<IProductGroup>
      resetAutoComplete={resetAutoComplete}
      placeholder={label}
      label={`${label} ${loading || isLoading ? 'กำลังโหลด...' : ''}`}
      onSelect={onSelect}
      search={search}
      onSearch={setSearch}
      options={
        data?.records
          .filter((group) => !productGroups?.includes(group.objectId))
          .map((group) => ({
            label: `${group.name} (${group.products?.length ?? 0} สินค้า)`,
            value: group,
          })) || ([] as IOptionSelect<IProductGroup>[])
      }
    />
  )
}

export default ProductGroupSelectSearch
